import GrayHeaderCard from "../../../../../ui/cards/gray-header-card/GrayHeaderCard";
import Grid from "@material-ui/core/Grid";
import {Button, FormControl, InputLabel} from "@material-ui/core";
import Input from "@material-ui/core/Input/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import {FilterList, Search} from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import InlineRadioButtons from "../../../../../ui/inputs/radio-buttons/inline-radio-buttons/InlineRadioButtons";
import React, {useState} from "react";
import {esitoInvioEmailRadioButtons} from "../EsitoInvioEmailHelper";
import PropTypes from "prop-types";
import {useSoglieFilterStyles} from "../../../soglie-eventi/soglie/soglie-filter/SoglieFilterStyles";
import EsitoInvioEmailFilterDialog from "../esito-invio-email-filter-dialog/EsitoInvioEmailFilterDialog";

const EsitoInvioEmailFilter = (props) => {
    const classes = useSoglieFilterStyles()
    const [searchText, setSearchText] = useState("")
    const [selectedRadioBtn, setSelectedRadioBtn] = useState(esitoInvioEmailRadioButtons[0].value)
    const [openFilterDialog, setOpenFilterDialog] = useState(false)

    const handleInputChange = (e) => {
        setSearchText(e.target.value)
    }

    const handleEnterPressed = (e) => {
        if (e.which === 13)
            handleSearchIcon()
    }

    const handleSearchIcon = () => {
        if (searchText.length !== 0) {
            props.handleSearchIcon(selectedRadioBtn, searchText)
            setSearchText("");
        }
    }

    const handleRadioBtnChange = (e) => {
        setSelectedRadioBtn(e.target.value)
    }

    return (
        <>
            <GrayHeaderCard title={<Typography variant='subtitle2'>Ricerca</Typography>}>
                <>
                    <Grid container
                          justifyContent="space-between"
                          alignItems="center">
                        <Grid item container
                              alignItems="center"
                              xs={12} sm={8} md={9}>
                            <FormControl fullWidth>
                                <InputLabel>
                                    {`Cerca ${esitoInvioEmailRadioButtons.find(r => r.value === selectedRadioBtn).text}`}
                                </InputLabel>
                                <Input labelid="filterSearchLabel"
                                       type="search"
                                       autoComplete="off"
                                       onChange={handleInputChange}
                                       value={searchText}
                                       onKeyPress={handleEnterPressed}
                                       endAdornment={
                                           <InputAdornment position="end">
                                               <IconButton onClick={handleSearchIcon}>
                                                   <Search/>
                                               </IconButton>
                                           </InputAdornment>
                                       }/>
                            </FormControl>

                            <Typography variant="subtitle2"
                                        display="inline"
                                        className={classes.typographyRadioButtons}
                                        color="textSecondary">
                                Cerca per
                            </Typography>

                            <InlineRadioButtons value={selectedRadioBtn}
                                                radioButtons={esitoInvioEmailRadioButtons}
                                                handleChange={handleRadioBtnChange}/>
                        </Grid>

                        <Grid item container
                              justifyContent="flex-end"
                              xs={12} sm={4} md={3}>
                            <Button variant="outlined"
                                    color="primary"
                                    className={classes.filterBtn}
                                    onClick={() => setOpenFilterDialog(true)}
                                    startIcon={<FilterList/>}>
                                Filtra
                            </Button>
                        </Grid>
                    </Grid>
                </>
            </GrayHeaderCard>

            {openFilterDialog ?
                <EsitoInvioEmailFilterDialog open={openFilterDialog}
                                             handleFilterSearch={props.handleSelectSearch}
                                             filter={props.filter}
                                             handleDialogClose={() => setOpenFilterDialog(false)}/> : null}

        </>
    )
}

EsitoInvioEmailFilter.propTypes = {
    handleSearchIcon: PropTypes.func.isRequired,
    handleSelectSearch: PropTypes.func.isRequired
}

export default EsitoInvioEmailFilter;
